(function($) {
  var $body = $('body'); 
  var $window = $(window);

  var $animationSections = $(".animation-section");
  var $backgroundSections = $(".js-has-background");

  function isVisible(scrollTop, windowHeight, sectionOffset, sectionHeight) {
    return scrollTop + windowHeight >= sectionOffset && scrollTop < sectionOffset + sectionHeight;
  }

  function handleScrollAnimations() {
    var scrollTop = $window.scrollTop();
    var windowHeight = $window.height();

    $animationSections.each(function(index) {
      var $el = $(this);
      var sectionOffset = $el.offset().top;
      var sectionHeight = $el.outerHeight(false);

      if (isVisible(scrollTop, windowHeight, sectionOffset, sectionHeight)) {
        $el.addClass("animation-activated");
      }
    });
  }

  function handleBackgroundTransitions() {
    if($backgroundSections.length) {
      var scrollTop = $window.scrollTop();
      var windowBottom = scrollTop + (0.8 * $window.height());
      var activeSectionIndex = 0;
      $backgroundSections.each(function(index) {
        var sectionOffset = $(this).offset();
        var thresholdHeight = 80;
        if(sectionOffset.top + thresholdHeight < windowBottom) {
          activeSectionIndex = index;
        } else {
          return false;
        }
      });
      $(".animation-background").css("opacity", 0);
      $(`.animation-background[data-index='${activeSectionIndex}']`).css("opacity", 1);
    }
  }

  function setAnimationDelays() {
    $animationSections.each(function(index) {
      var $section = $(this);
      var $animatedElements = $section.find(".animate");
      var delay = 0.2;
      $animatedElements.each(function(index) {
        var $el = $(this);
        $el.css({
          "transition-delay": index * delay + "s"
        });
      });
    });
  }

  document.addEventListener('scroll', (evt) => {
    var scrollTop = $window.scrollTop();

    //show top menu on scroll
    if(scrollTop){
      $body.addClass("scrolled");
    }else{
      $body.removeClass("scrolled");
    }

    //animate elements on scroll
    handleScrollAnimations();

    //transition fixed backgrounds
    handleBackgroundTransitions();
  }, {
    capture: true,
    passive: true
  }); 

  setAnimationDelays();

  setTimeout(function() {
    handleScrollAnimations();
  });

})(jQuery);